import React from "react";
import UserMenu from "./Profile/UserProfile";
import "./Header.css";
import logo from "../../../Assets/logo.png";
import { useTranslation } from "react-i18next";
const Header = (presencesProfile) => {
    const { t } = useTranslation();
  return (
    <div className="header">
      <div className="logo-container">
        <img src={logo} alt="Heedify Logo" className="logo" />
      </div>

    <h2 className="title">{t("WELCOME.TITLE")} </h2>
      <UserMenu presencesProfile={presencesProfile} />
    </div>
  );
};

export default Header;
